// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 任务执行历史 实体类
 * 任务执行历史
 */
export class TaskExecuteHisitory extends BaseEntity {
  /** 标题 : 标题 */
  private _title: string;

  /** 设置：标题 */
  public get title() {
    return this._title;
  }

  /** 获取：标题 */
  public set title(value: string) {
    this._title = value;
  }

  constructor() {
    super();
    this._title = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: TaskExecuteHisitory, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.title = element.title;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.title = json.Title;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Title = this.title;
  }

  static Create(json: any): TaskExecuteHisitory {
    const taskExecuteHisitory = new TaskExecuteHisitory();
    taskExecuteHisitory.Deserialize(json);
    taskExecuteHisitory.json = json;
    return taskExecuteHisitory;
  }
}
